<template>
    <div id="general-information">
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="pa-0">
                            <v-icon :color="subAppColor" left>mdi-medical-bag</v-icon>Standard First Aid Training
                        </v-card-subtitle>
                        <v-text-field v-model="item.firstAidTrainingInitials" label="Initial(s)"
                            placeholder="Not Available" prepend-icon="mdi-draw" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="pa-0">
                            <v-icon :color="subAppColor" left>mdi-card-account-details</v-icon>Canadian Social Insurance
                            Number
                        </v-card-subtitle>
                        <v-text-field v-model="item.sinCardInitials" label="Initial(s)" placeholder="Not Available"
                            prepend-icon="mdi-draw" readonly>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-card-subtitle class="pt-0 px-0">
                            <v-icon :color="subAppColor" left>mdi-allergy</v-icon>Food/Allergies Concern(s)
                            Number
                        </v-card-subtitle>
                        <v-checkbox v-model="item.allergiesType" dense hide-details label="Vegetarian" multiple readonly
                            value="Vegetarian">
                        </v-checkbox>
                        <v-checkbox v-model="item.allergiesType" dense hide-details label="Vegan" multiple readonly
                            value="Vegan">
                        </v-checkbox>
                        <v-checkbox v-model="item.allergiesType" dense hide-details label="Gluten Intolerant" readonly
                            multiple value="Gluten Intolerant">
                        </v-checkbox>
                        <v-checkbox v-model="item.allergiesType" dense hide-details label="Lactose Intolerant" readonly
                            multiple value="Lactose Intolerant">
                        </v-checkbox>
                        <v-checkbox v-model="item.allergiesType" dense label="Food Allergies" multiple readonly
                            value="Food Allergies">
                        </v-checkbox>
                        <v-textarea v-model="item.allergiesConcern" auto-grow hide-details
                            label="Food/Allergies Concern(s)" outlined persistent-hint placeholder="Not Available"
                            readonly>
                        </v-textarea>
                    </v-col>
                    <v-col cols="12">
                        <v-card-subtitle class="pb-0 px-0">
                            <v-icon :color="subAppColor" left>mdi-calendar-remove</v-icon>Need To Miss Training On
                            Certain
                            Day(s)
                        </v-card-subtitle>
                        <v-card-title class="px-0" v-if="item.trainingDaysMissed.length == 0">
                            None
                        </v-card-title>
                        <v-list v-else>
                            <v-list-item v-for="(item, i) in item.trainingDaysMissed" :key="i">
                                <v-list-item-avatar>
                                    <v-icon :color="dangerColor" dark>
                                        mdi-calendar-remove
                                    </v-icon>
                                </v-list-item-avatar>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.date"></v-list-item-title>
                                    <v-list-item-subtitle v-text="item.reason"></v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col cols="12" class="pb-0">
                        <v-card-subtitle class="pa-0">
                            <v-icon :color="subAppColor" left>mdi-tshirt-crew</v-icon>You will receive an RA shirt
                        </v-card-subtitle>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-radio-group v-model="item.shirtSize" label="Shirt size" readonly>
                            <v-radio v-for="(item, index) in shirtSizeItems" :key="index" :label="item.text"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-radio-group v-model="item.shirtStyle" class="mt-4" label="Shirt style" readonly>
                            <v-radio v-for="(item, index) in shirtStyleItems" :key="index" :label="item.text"
                                :value="item.value"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="item.shirtDescription" label="Name to appear on the shirt"
                            placeholder="Not Available" readonly>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'ra-applicant-general-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            shirtSizeItems: [{
                    text: 'XS',
                    value: 'XS'
                },
                {
                    text: 'S',
                    value: 'S'
                }, {
                    text: 'M',
                    value: 'M'
                },
                {
                    text: 'LG',
                    value: 'LG'
                },
                {
                    text: 'XL',
                    value: 'XL'
                },
                {
                    text: 'XXL',
                    value: 'XXL'
                }
            ],
            shirtStyleItems: [{
                    text: `Men's style`,
                    value: 'M'
                },
                {
                    text: 'Ladies style',
                    value: 'F'
                }
            ]
        }
    },
    computed: {
        dangerColor() {
            return '#f64e60';
        },
        infoColor() {
            return '#5578eb';
        },
        subAppColor() {
            return '#FFA800';
        }
    }
}
</script>

<style scoped>
.v-input--checkbox {
    margin-top: 0 !important;
}
</style>